<template>
    <div>

        <!--导航栏  @click-left="onClickLeft"  left-arrow left-text="返回"-->
        <van-nav-bar
                title="业务员登录"



                fixed
        />
        <!--导航栏-->

        <van-form @submit="onSubmit" style="margin-top: 1.5rem">
            <van-field
                    v-model="username"
                    name="username"
                    clearable
                    label="账号"
                    placeholder="请输入业务员编号或手机号登录"
                    :rules="[{ required: true, message: '请输入业务员编号或手机号登录' }]"
            />
            <van-field
                    v-model="password"
                    type="password"
                    name="password"
                    clearable
                    label="密码"
                    placeholder="请输入业务员的密码"
                    :rules="[{ required: true, message: '请填写密码' }]"
            />
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    登录
                </van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
    import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';

    export default {
        name: "SalesmanLogin",
        data() {
            return {
                username: '',
                password: '',
                redirect: "",
                openid: "",
            };
        },
        created() {
            //重定向地址
            this.redirect = this.$route.query.redirect;
            if (this.redirect == undefined) {
                this.redirect = '/SalesmanHome';
            }
                this.openid = this.$route.query.openid;
                this.wxSalesman()
        },
        methods: {
            wxSalesman(){
                if(!this.openid){
                    this.openid = localStorage.getItem('openid')
                }
                var toast = Toast.loading({
                        duration: 0,
                        message: '自动登录中',
                        forbidClick: true,
                        loadingType: 'spinner',
                    });
                this.$http.get('/wechat/api.agent/wxSalesman', {
                    params: {
                        "openid": this.openid
                    }
                }).then(response => {
                    toast.clear();
                    if (response && response.data.code == 200) {
                        VueCookie.set('salesmanInfo', response.data.data, 360000);
                        window.sessionStorage.setItem("tag", 'salesman_log');
                        window.localStorage.setItem("salesman_token",response.data.data.salesman_token)
                        window.localStorage.setItem("salesman_id",response.data.data.id)
                        this.$router.push(this.redirect);
                    } else {
                        Notify({type: 'danger', message: response.data.msg});
                    }
                });
            },
            onSubmit(values) {
                var toast = Toast.loading({
                    duration: 0,
                    message: '登录中',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                console.log('submit', values);
                this.$http.get('/wechat/api.agent/loginSalesman', {
                    params: {
                        username: this.username,
                        password: this.password,
                        openid: this.openid
                    }
                }).then(response => {
                    toast.clear();
                    if (response && response.data.code == 200) {
                        VueCookie.set('salesmanInfo', response.data.data, 360000);
                        window.sessionStorage.setItem("tag", 'salesman_log');
                        window.localStorage.setItem("salesman_token",response.data.data.salesman_token)
                        window.localStorage.setItem("salesman_id",response.data.data.id)
                        this.$router.push(this.redirect);
                    } else {
                        Notify({type: 'danger', message: response.data.msg});
                    }
                });

            }
        },
    }
</script>

<style scoped>

</style>
